<template>
  <div>
    <div class="columns" style="justify-content: center">
      <div
        :class="`column is-${reverse ? 12 : 11} columns is-flex-direction-row-${
          reverse ? 'reverse' : ''
        }`"
        style="justify-content: space-between; margin: 0px"
      >
        <div class="column is-3 is-hidden-mobile">
          <div
            :class="`animate__animated animate__fadeIn${
              reverse ? 'Right' : 'Left'
            }`"
            :style="`position: sticky; top: 106px;height:${
              height ? height : ''
            }px${reverse ? 'width:80%' : ''}`"
          >
            <TextTitle
              :animate="false"
              :title="sideTitle"
              fontWeight="700"
              :subTitle="true"
              :style="`padding-top: ${reverse ? 27 : 50}px`"
            />
            <div style="padding-top: 20px">
              <div
                v-for="(item, i) in title"
                :key="i"
                :class="`hero ${
                  active === i ? 'has-text-green' : ''
                } title-section`"
                @click="onclickTitle(i)"
              >
                <h4
                  :class="`mist-${language}-h4 mist-h4`"
                  :style="`font-weight:${
                    active === i ? (language === 'en' ? 600 : 500) : 400
                  }!important`"
                >
                  {{ item }}
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-8 animate__animated animate__fadeInUp">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "sideTitle", "reverse", "height"],
  components: {
    TextTitle: () => import(`@/components/TextTitle`),
  },
  data() {
    return {
      paragraph: null,
      active: 0,
    };
  },
  computed: {
    language() {
      return this.$store.getters["language/language"];
    },
  },
  methods: {
    onclickTitle(index) {
      this.active = index;
      this.$emit("onclickTitle", index);
    },
  },
};
</script>

<style scoped>
.title-section {
  padding: 10px 0;
  cursor: pointer;
  text-align: left;
}
.mist-h4 {
  font-weight: 600;
}
.mist-p {
  padding: 30px 0 0;
}
.img-about {
  max-height: 425.54px;
  width: 100%;
}
</style>